export default __webpack_public_path__ + "static/media/net_ball_half.ab9dbdd5.png";